<template lang="pug"></template>
<script>
  export default {
    name: 'address-menu',
    sort: 8,
    module: 'address',
    data() {
      return {
        sort: 8,
        module: 'address'
      }
    },
    created() {},
    computed: {},
    methods: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?0458c9c7